module.exports = __webpack_public_path__ + "static/media/XDG.63a76db6.png";